<template>
  <!-- TODO turn this into two column layout to be more mobile friendly _or_ make them sit under each other if screen width is too narrow -->
  <div class="cv-chunk">
    <!-- CV section -->
    <div class="flex-grid-two-column">
      <div class="sml-col"><h1 class="date-header">{{yearRange}}</h1></div>
      <div class="container-col">
        <div class="col">
        <!-- <img src="../assets/work.svg"/> -->
        <h1>{{jobColumnHeader}}</h1>
        <h3>{{jobColumnSubHead}}</h3>
        <slot name="jobContent"/>
      </div>
      <div class="col">
        <!-- <img src="../assets/cap3.svg"/> -->
        <h1>{{academiaColumnHeader}}</h1>
        <h3>{{academiaColumnSubHead}}</h3>
        <slot name="academiaContent"/>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CvChunk',
  props: {
    yearRange: String,
    jobColumnHeader: String,
    jobColumnSubHead: String,
    academiaColumnHeader: String,
    academiaColumnSubHead: String,
  }
}
</script>

<style scoped>
.date-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
}
.flex-grid {
  display: flex;
}
.col {
  flex: 1;
}

.flex-grid-two-column {
  display: flex;
  justify-content: space-between;
}

.flex-grid-two-column .container-col {
  width: 77%;
  text-align: left;
}

.flex-grid-two-column .col {
  width: 77%;
  text-align: left;
  padding-left: 3em;
}

.flex-grid-two-column .sml-col {
  width: 19%;
  text-align: left;
}

h1 {
  margin: 30px 0 30px 0;
}
h3 {
  margin: 40px 0 0;
}

@media screen and (max-width: 500px) {
  .flex-grid {
    display: block;
  }
}
</style>
